import { Directive, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { FormObjectComponent } from "../../../shared/forms/form-object.component";

@Directive()
export abstract class EstimateComopnent extends FormObjectComponent {
    @Input() override form: UntypedFormGroup;

    public abstract get total(): number;
}